import { render, staticRenderFns } from "./equiDetail.vue?vue&type=template&id=3a5729b8&"
import script from "./equiDetail.vue?vue&type=script&lang=js&"
export * from "./equiDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports